import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  DateField,
  FunctionField,
  TextInput,
} from "react-admin";

import { Chip } from "@mui/material";



const AssessmentResponseList = () => {
  return (
    <List
      
    >
      <Datagrid
        rowClick="show"
        sx={{
          "& .RaDatagrid-row": {
            borderRadius: "12px",
            mb: 1,
          },
        }}
      >
        {/* ATTEMPT ID */}
        <TextField source="attempt_id" label="Attempt ID" />

        {/* USER ID */}
        <TextField source="user_id" label="User ID" />

        {/* ASSESSMENT */}
        <TextField
          source="assessment_title"
          label="Assessment"
        />

        {/* SCORE */}
        <FunctionField
          label="Score"
          render={(record) => (
            <Chip
              label={`${record.score || 0}`}
              size="small"
              color="primary"
            />
          )}
        />

        {/* TOTAL SCORE */}
        <FunctionField
          label="Total Score"
          render={(record) => (
            <Chip
              label={`${record.total_score || 0}`}
              size="small"
            />
          )}
        />

        {/* PERCENTAGE */}
        <FunctionField
          label="Percentage"
          render={(record) => (
            <Chip
              label={`${record.percentage || 0}%`}
              size="small"
              color={
                record.percentage >= 70
                  ? "success"
                  : "warning"
              }
            />
          )}
        />

        {/* PASSING SCORE */}
        <FunctionField
          label="Passing Score"
          render={(record) => (
            <Chip
              label={record.passing_score || 0}
              size="small"
            />
          )}
        />

        {/* PASS STATUS */}
        <FunctionField
          label="Passed"
          render={(record) => (
            <Chip
              label={
                record.pass_status
                  ? "Passed"
                  : "Failed"
              }
              size="small"
              color={
                record.pass_status
                  ? "success"
                  : "error"
              }
            />
          )}
        />

        {/* STARTED AT */}
        <DateField
          source="started_at"
          label="Started At"
          showTime
        />

        {/* SUBMITTED AT */}
        <DateField
          source="submitted_at"
          label="Submitted At"
          showTime
        />
      </Datagrid>
    </List>
  );
};

export default AssessmentResponseList;